// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__VkLTE","hand":"Spinner_hand__1XFKy","rotate":"Spinner_rotate__vSExA","invisible":"Spinner_invisible__C0cdf"};